var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66668 1.16675H3.00001C2.55798 1.16675 2.13406 1.34234 1.8215 1.6549C1.50894 1.96746 1.33334 2.39139 1.33334 2.83341V16.1667C1.33334 16.6088 1.50894 17.0327 1.8215 17.3453C2.13406 17.6578 2.55798 17.8334 3.00001 17.8334H13C13.442 17.8334 13.866 17.6578 14.1785 17.3453C14.4911 17.0327 14.6667 16.6088 14.6667 16.1667V6.16675M9.66668 1.16675L14.6667 6.16675M9.66668 1.16675V6.16675H14.6667M8.00001 14.5001V9.50008M5.50001 12.0001H10.5",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePlus);
export default __webpack_public_path__ + "static/media/filePlus.b6f3c6714f7ce9196ad0b075a3c556f9.svg";
export { ForwardRef as ReactComponent };